"use strict";

import Vue from 'vue';
import Control from './Control';

/**
 * Control zur Auswahl von Hintergrundkartenebenen.
 *
 * @class
 * @extends gc.gis.control.GCAbstractMapControl
 * @memberof gc.gis.control
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe {@link gc.gis.control.GCAbstractMapControl})
 * @param {boolean} [options.enableVoidLayer=true]
 */
gc.gis.control.GCBackgroundLayerSwitcher = function(options)
{
    gc.gis.control.GCAbstractMapControl.call(this, options);

    this._layers = [];
    this.vm = {
        controller: this,
        layers: this._layers
    };

    if (options.enableVoidLayer !== false)
    {
        this._registerVoidLayer();
    }

    const self = this;
    this._map.on(gc.gis.map.GCMapEvent.BACKGROUND_LAYER_ADDED, this, function (event) {
        self._registerLayerList(event.layers, event.drawOrders, event.previewClassNames, event.previewImages)
    });
};
gc.gis.control.GCBackgroundLayerSwitcher.prototype = Object.create(gc.gis.control.GCAbstractMapControl.prototype);

/**
 * @private
 */
gc.gis.control.GCBackgroundLayerSwitcher.prototype._registerVoidLayer = function()
{
    this._layers.push({
        isVoid: true,
        isVisible: true,
        label: 'kein Hintergrund',
        abstract: 'keine Hintergrundkarte',
        drawOrder: Number.MIN_SAFE_INTEGER
    });
};

/**
 * @private
 * @param {gc.gis.layer.GCAbstractLayer[]} layers
 * @param {Number[]} drawOrders
 * @param {String[]} previewClassNames
 * @param {String[]} previewImages
 */
gc.gis.control.GCBackgroundLayerSwitcher.prototype._registerLayerList = function(layers, drawOrders, previewClassNames, previewImages)
{
    for (let i = 0, ii = layers.length; i < ii; i++)
    {
        let drawOrder = i < drawOrders.length ? drawOrders[i] : -1;
        let previewClassName = i < previewClassNames.length ? previewClassNames[i] : undefined;
        let previewImage = i < previewImages.length ? previewImages[i] : undefined;
        this._registerLayer(layers[i], drawOrder, previewClassName, previewImage);
    }
};

/**
 * @private
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @param {Number} drawOrder
 * @param {String} previewClassName
 * @param {String} previewImage
 */
gc.gis.control.GCBackgroundLayerSwitcher.prototype._registerLayer = function(layer, drawOrder, previewClassName, previewImage)
{
    const layerModel = {
        _ref: layer,
        isVisible: layer.isVisible(),
        label: layer.getLabel(),
        abstract: layer.getAbstract(),
        drawOrder: drawOrder,
        previewClassName: previewClassName,
        previewImage: previewImage
    };

    this._layers.push(layerModel);

    if (layer.isVisible())
    {
        this.showBackgroundLayer(layerModel);
    }
};

/**
 * @inheritdoc
 */
gc.gis.control.GCBackgroundLayerSwitcher.prototype.init = function()
{
    // Vue.config.devtools = true;

    const BackgroundLayerControl = Vue.extend(Control);
    this._element = new BackgroundLayerControl({
        data: this.vm
    });
};

gc.gis.control.GCBackgroundLayerSwitcher.prototype.showBackgroundLayer = function (bgLayer) {
    for (let i = 0, ii = this._layers.length; i < ii; i++)
    {
        const isVisible = this._layers[i] === bgLayer;
        this._layers[i].isVisible = isVisible;
        if (!this._layers[i].isVoid)
        {
            this._layers[i]._ref.setVisible(isVisible);
        }
    }
};